export default __webpack_public_path__ + "static/media/pdlogo.6cf4aa13.png";